import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './responsive-header.scss';
import {
  LightboxInfoIcon,
  ShareArrow,
} from '@wix/wix-vod-shared/dist/esm/icons/compiled';
import CloseButton from '@wix/wix-vod-shared/dist/esm/widget/ui-components/close-button/close-button';
import { withTranslation } from '@wix/yoshi-flow-editor';
import AccountButton from '../../../components/account/account-button/account-button';
import { sides } from '../../../constants/popout';
import ChannelActionsContainer from '../../../containers/channel-actions/channel-actions';
import ChannelSubscriptionButton from '../../../components/channel-actions/channel-subscription-button';
import { isSubscriptionButtonVisible } from '../../../components/overlay-texts/channel/subscribe-button-text-utils';
import Icon from '../../../components/icon/icon';
import {
  canShowExpandedChannelTitle,
  canShowChannelTitle,
  canShowExpandedSignIn,
  getCanShowChannelShare,
  getCanShowChannelInfo,
  canShowExpandedVideoShare,
  isResponsiveEditor,
} from '../../../selectors/app-settings';
import { isSingleVideo } from '../../../selectors/video';
import { isEditorMode } from '../../../selectors/view-mode';

const mapStateToProps = (state, { channel }) => ({
  isSubscriptionVisible: isSubscriptionButtonVisible({ channel }),
  isSignInVisible: canShowExpandedSignIn(state),
  isTitleVisibleExpanded: canShowExpandedChannelTitle(state),
  isTitleVisible: canShowChannelTitle(state),
  isChannelInfoVisible: getCanShowChannelInfo(state),
  isShareChannel: getCanShowChannelShare(state),
  isShareExpandedVideo: canShowExpandedVideoShare(state),
  isResponsiveEditor: isResponsiveEditor(state),
  isSingleVideo: isSingleVideo(state),
  isEditor: isEditorMode(state),
});

const ResponsiveHeader = connect(mapStateToProps)(
  class ResponsiveHeader extends React.Component {
    static propTypes = {
      channel: PropTypes.object.isRequired,
      isSubscriptionVisible: PropTypes.bool.isRequired,
      isSignInVisible: PropTypes.bool.isRequired,
      isTitleVisible: PropTypes.bool.isRequired,
      isShareExpandedVideo: PropTypes.bool.isRequired,
      isShareChannel: PropTypes.bool.isRequired,
      isResponsiveEditor: PropTypes.bool,
      isEditor: PropTypes.bool,
      onCloseClick: PropTypes.func,
      onShareClick: PropTypes.func,
      onPageRefresh: PropTypes.func,
      onAccountClick: PropTypes.func,
      onChannelClick: PropTypes.func,
      onBackButtonClick: PropTypes.func,
    };

    renderShareButton(isShareVisible) {
      const { onShareClick, t } = this.props;

      return (
        isShareVisible && (
          <button className={styles.share} onClick={onShareClick}>
            <ShareArrow />
            <span className={styles.shareText}>
              {t('widget.action-button-labels.share-video-short')}
            </span>
          </button>
        )
      );
    }

    renderAccountButton(channelActions) {
      const { onAccountClick, channel } = this.props;

      return (
        <AccountButton
          className={styles.user}
          channelData={channel}
          tooltipSide={sides.BOTTOM}
          onClick={onAccountClick}
          onLoginClick={channelActions.logIn}
          onLogoutClick={channelActions.logOut}
          onSubscribeClick={channelActions.subscribe}
        />
      );
    }

    renderSubscriptionButton(channelActions) {
      const { channel } = this.props;

      return (
        <ChannelSubscriptionButton
          onClick={channelActions.subscribe}
          className={styles.subscribe}
          channelData={channel}
        />
      );
    }

    renderDelimiter() {
      return <div className={styles.delimiter} />;
    }

    render() {
      const {
        channel,
        isSignInVisible,
        isSubscriptionVisible,
        onCloseClick,
        onPageRefresh,
        onBackButtonClick,
        isShareChannel,
        isShareExpandedVideo,
        isChannelInfoVisible,
        isTitleVisible,
        isTitleVisibleExpanded,
        onChannelClick,
        isEditor,
      } = this.props;

      const isShareVisible = this.props.isResponsiveEditor
        ? isShareChannel
        : isShareExpandedVideo;

      const isTitleDisplayed = this.props.isResponsiveEditor
        ? isTitleVisible
        : isTitleVisibleExpanded;

      return (
        <div className={styles.header}>
          <button className={styles.backButton} onClick={onBackButtonClick}>
            <Icon name="permit-search" />
          </button>

          {!this.props.isSingleVideo && (
            <div className={styles.channel} onClick={onChannelClick}>
              {isTitleDisplayed && <span>{channel.title}</span>}
              {isChannelInfoVisible && (
                <LightboxInfoIcon className={styles.infoIcon} />
              )}
            </div>
          )}

          {!this.props.isSingleVideo &&
            (isTitleDisplayed || isChannelInfoVisible) &&
            (isSignInVisible || isSubscriptionVisible || isShareVisible) &&
            this.renderDelimiter()}

          <ChannelActionsContainer
            onPageRefresh={onPageRefresh}
            channelId={channel.id}
          >
            {(channelActions) => (
              <>
                {isSignInVisible && this.renderAccountButton(channelActions)}

                {isSignInVisible &&
                  isSubscriptionVisible &&
                  this.renderDelimiter()}

                {isSubscriptionVisible &&
                  this.renderSubscriptionButton(channelActions)}

                {(isSignInVisible || isSubscriptionVisible) &&
                  isShareVisible &&
                  this.renderDelimiter()}
              </>
            )}
          </ChannelActionsContainer>
          {this.renderShareButton(isShareVisible)}
          {!isEditor && (
            <CloseButton
              className={styles.closeButton}
              onClick={onCloseClick}
            />
          )}
        </div>
      );
    }
  },
);

export default withTranslation()(ResponsiveHeader);
